import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ResponseStatus } from '@app/core/enums/response-status.enum';
import { HttpServerResponse } from '@app/core/models/response.model';
import { LoggerService } from '@app/core/services/logger.service';
import { CatalogCFDICommand } from '@app/modules/clients/command/get-catalog-cfdi.command';
import { ClientsServiceService } from '@app/modules/clients/services/clients-service.service';
import { UsersService } from '../../../modules/management/services/users.service';

const logger = new LoggerService('FormDataBillingFieldsComponent');

export interface DataBilling {
  typePerson: any;
  rfc: string;
  businessname: string;
  cp: string;
  taxRegime: any;
  useCFDI: any;
  preferedData: boolean;
}

interface CatTypePerson {
  id: string;
  name: string;
  description: string;
}

export interface ModelDataBilling {
  isValid: boolean;
  data: DataBilling;
}

@Component({
  selector: 'dhl-form-data-billing-fields',
  templateUrl: './form-data-billing-fields.component.html',
  styleUrls: ['./form-data-billing-fields.component.scss']
})
export class FormDataBillingFieldsComponent implements OnInit {
  @Input() taxRegimeList: any = [];
  @Input() catCFDIList: any = [];
  @Input() typePersonList: any = [];
  @Input() patchValues!: boolean;
  @Input() data!: DataBilling;

  @Output() formChanged = new EventEmitter<boolean>();

  taxRegimeId: string = '';

  dataBillingValues: DataBilling = {
    typePerson: null,
    rfc: '',
    businessname: '',
    cp: '',
    taxRegime: null,
    useCFDI: null,
    preferedData: false
  };

  dataBilling: ModelDataBilling = {
    isValid: false,
    data: this.dataBillingValues
  };

  isPreferenceDataF: boolean = true;
  formDataBilling: FormGroup;
  showDatafacturingAdd: boolean = false;

  typePerson: string = '';

  pf!: HTMLInputElement;
  pm!: HTMLInputElement;

  valueCp: string = '';

  selectFact1: boolean = true;
  selectFact2: boolean = false;
  showDataFact: boolean = false;

  @ViewChild('silder') silder!: ElementRef;
  @ViewChild('circleSlid') circleSlid!: ElementRef;
  @ViewChild('divSlider') divSlider!: ElementRef;
  @ViewChild('isPreference') isPreference!: ElementRef;

  constructor(private readonly formBuilder: FormBuilder, private readonly userService: UsersService, private readonly clientService: ClientsServiceService, public router: Router) {
    this.formDataBilling = this.formBuilder.group({
      businessName: ['', [Validators.required]],
      rfc: ['', [Validators.required]],
      cp: ['', [Validators.required, this.validatePostalCode]],
      taxRegime: ['', [Validators.required]],
      useCFDI: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.onLoadData();
  }

  onLoadData(): void {
    if (this.patchValues && this.data.typePerson != null) {
      this.formDataBilling.get('rfc')?.setValue(this.data.rfc);
      this.formDataBilling.get('businessName')?.setValue(this.data.businessname);
      this.formDataBilling.get('cp')?.setValue(this.data.cp);
      this.formDataBilling.get('taxRegime')?.setValue(this.data.taxRegime);

      const name = this.taxRegimeList.find((type: CatTypePerson) => type.id.includes(this.data.taxRegime)).name;
      const command: CatalogCFDICommand = {
        id: this.data.taxRegime,
        Name: name
      };

      this.callServiceCatalogCFDI(command, 2);
      this.typePerson = this.typePersonList.find((type: CatTypePerson) => type.id.includes(this.data.typePerson)).name;
      this.isPreferenceDataF = this.data.preferedData;
      logger.debug(this.typePerson);
    } else {
      this.typePerson = '';
    }

    this.formDataBilling.valueChanges.subscribe((value) => {
      this.formChanged.emit(value);
    });
  }

  validAndObtainDtaBilling(): any {
    const isErrors: boolean[] = [];

    // Valdamos si existen errores en el formulario
    if (this.formDataBilling.invalid) {
      isErrors.push(true);
    }

    // Validamos si hay error en el campo de tipo de persona y si hay, agregamos un isError a true
    if (!this.typePerson) {
      isErrors.push(true);
    }

    // Con esto validamos si existe enrrores dentro del formulario y lo mandamos como respuesta al componente padre
    this.dataBilling.isValid = isErrors.length > 0 ? false : true;

    // Si todo está correcto en el formulario obtenemos los valores, si no pues nel im sorry for you
    if (isErrors.length === 0) {
      // Obtenemos los datos del formulario
      this.dataBilling.data.typePerson = this.typePersonList.find((typee: CatTypePerson) => typee.name.includes(this.typePerson)).id;
      this.dataBilling.data.cp = this.formDataBilling.get('cp')?.value.toString();
      this.dataBilling.data.rfc = this.formDataBilling.get('rfc')?.value;
      this.dataBilling.data.useCFDI = this.formDataBilling.get('useCFDI')?.value;
      this.dataBilling.data.taxRegime = this.formDataBilling.get('taxRegime')?.value;
      this.dataBilling.data.businessname = this.formDataBilling.get('businessName')?.value;
      this.dataBilling.data.preferedData = this.isPreferenceDataF;
    }

    logger.debug(this.dataBilling);

    return this.dataBilling;
  }

  changeValueTypePerson(typePerson: string) {
    this.typePerson = typePerson.includes('pf') ? 'Persona Física' : 'Persona Moral';
    const rfc = this.formDataBilling.get('rfc')!;

    if (this.typePerson === 'Persona Física') {
      rfc.setValidators([Validators.required, this.rfcValidatorFisica()]);
    } else {
      rfc.setValidators([Validators.required, this.rfcValidatorMoral()]);
    }

    rfc.updateValueAndValidity();
  }

  rfcValidatorFisica(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: unknown } | null => {
      const rfc = control.value;
      const regexPersonaFisica = /^[A-Z]{4}\d{6}[A-Z0-9]{3}$/;
      let isValid = false;
      if (regexPersonaFisica.test(rfc)) {
        isValid = true;
      }

      return isValid ? null : { rfcInvalido: true };
    };
  }

  rfcValidatorMoral(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: unknown } | null => {
      const rfc = control.value;
      const regexPersonaMoral = /^[A-Z]{3}\d{6}[A-Z0-9]{3}$/;
      let isValid = false;
      if (regexPersonaMoral.test(rfc)) {
        isValid = true;
      }

      return isValid ? null : { rfcInvalido: true };
    };
  }

  validCP(event: any) {
    const input = event.target as HTMLInputElement;
    if (!/^\d+$/.test(input.value)) {
      input.value = input.value.substring(0, input.value.length - 1);
    }
    const value = input.value.slice(0, 5);
    input.value = value;
  }

  handleCnahgeValueOfDataPreference(newValueVariable: boolean) {
    this.isPreferenceDataF = newValueVariable;
  }

  changeValueIsPreferentData(event: any) {
    this.isPreferenceDataF = event.checked;
  }

  selectCFDI(event: any) {
    const name = this.taxRegimeList.find((type: CatTypePerson) => type.id.includes(event.value)).name;
    const command: CatalogCFDICommand = {
      id: event.value,
      Name: name
    };
    this.taxRegimeId = event.value;
    this.callServiceCatalogCFDI(command, 1);
  }

  callServiceCatalogCFDI(command: CatalogCFDICommand, escena: number) {
    this.clientService.getCatalogCFDI(command).subscribe({
      next: (response: HttpServerResponse<any>) => {
        if (response.status === ResponseStatus.Ok) {
          logger.info('[OK] GET DATA CFDI');
          this.catCFDIList = response.data;
          if (escena === 2) {
            this.formDataBilling.get('useCFDI')?.setValue(this.data.useCFDI);
          }
        }
      },
      error: (e) => {
        logger.info('[FAIL] GET DATA CFDI', e);
      },
      complete: () => {
        logger.info('process complete');
      }
    });
  }

  getTaxRegimeId(): string {
    return this.taxRegimeId;
  }

  getUseCFDI(): any {
    return this.catCFDIList;
  }

  validatePostalCode(control: { value: string }): { [key: string]: any } | null {
    const postalCodePattern = /^\d{5}$/; // Patrón para un código postal válido (5 dígitos).

    if (control.value && !postalCodePattern.test(control.value)) {
      return { invalidPostalCode: true };
    }

    return null;
  }

  convertirAMayusculas(event: any) {
    event.target.value = event.target.value.toUpperCase();
  }
}
